
// const HOST_DOMAIN = 'http://49.234.183.197:8080/api';
const { host } = window.location;
const FILE_DOMAIN = host.includes('localhost') ? 'https://dev.scqz.bjwang.top/' : '/';
const DOWNLOAD_DOMAIN = `${window.location.protocol}//${window.location.host}`;
const ENV = (host.includes('test') || host.includes('localhost')) ? 'test' : 'prod';

export default {
  // HOST_DOMAIN,
  FILE_DOMAIN,
  API_URI: '/api',
  version: '1.0.0',
  default_l10n: 'zh_CN',
  DOWNLOAD_DOMAIN,
  ENV,
};
